module.exports = __webpack_public_path__ + "img/vc.bbb52fa0.svg";